<template>
	<div>
		<el-tabs v-model="chooseTab" @tab-change="handleClick" class="p-2">
            <el-tab-pane
                v-for="(item, index) in planTypeTabs"
                :key="item.name"
                :label="item.label"
                :name="item.name"
            >
                <div v-if="filterParams.plan_type == item.name">
                    <div>
                        <div class="list-item d-flex justify-content-between align-items-center" v-for="sub in subscriptions.data" :key="sub.id">
                            <div>
                                <p class="list-item__title">
                                    {{ sub.plan.name }}
                                    <span v-if="sub.status == '0200'" class="badge badge-warning">{{ $t("orders.mStatus.pending_payment") }}</span>
                                    <span v-if="sub.status == '9800'" class="badge badge-danger">{{ $t("orders.mStatus.abnormal_done") }}</span>
                                    <span v-if="sub.status == '9810'" class="badge badge-dark">{{ $t("orders.mStatus.expired") }}</span>
                                    <span v-if="sub.status == '9900'" class="badge badge-success">{{ $t("orders.mStatus.active") }}</span>
                                </p>
                                <p v-if="sub.start_at" class="list-item__subtitle text-muted">
                                    <span>{{ t("subscriptions.startAt") }}: {{ dateFormat(sub.start_at, format) }} ~ {{ dateFormat(sub.ended_at, format) }}</span>
                                </p>
                                <p v-if="sub.order" class="list-item__subtitle text-muted">
                                    <span v-if="sub.order.paid_last_at">{{ t("subscriptions.paidAt") }}: {{ dateFormat(sub.order.paid_last_at, format) }}</span>
                                    <span v-else>{{ t("subscriptions.notPaidYet") }}</span>
                                    <span> ({{ checkValidCurrencyStr(sub.order.total, sub.order.currency) }})</span>
                                </p>
                            </div>
                            <div>
                                <a v-if="sub.order && sub.order.status == '0200'" :href="'/pay/'+sub.order.id"
                                   class="btn btn-info p-2 mr-2 top-margin">
                                    <i class="fa fa-money"></i> {{ t("subscriptions.goToPayment") }}
                                </a>
                                <button
                                  v-if="sub.order && sub.order.status == '0200'"
                                  class="btn btn-secondary p-2 top-margin"
                                  @click="onClickChangePayment(sub.order)"
                                >
                                  <i class="fa fa-pencil-square-o"></i> {{ t("subscriptions.changePaymentMethod") }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-if="!subscriptions.data.length" class="mt-3 mb-2 text-center">
                      {{ t("global.empty") }}
                    </div>
                    <div v-if="subscriptions.paging" class="card-footer">
                      <!-- Pagination-->
                      <nav class="d-flex justify-content-between pt-2" aria-label="Page navigation">
                        <ul class="pagination">
                          <li class="page-item">
                            <el-button :disabled="subscriptions.paging.page - 1 < 1" @click="handlePrePage">
                              <i class="czi-arrow-left mr-2"></i>
                              {{ t("paging.prevPage") }}
                            </el-button>
                          </li>
                        </ul>
                        <ul class="pagination">
                            <li class="page-item d-none d-sm-block">
                              <span class="page-link page-link-static">
                                {{subscriptions.paging.page}} / {{totalPage}} ({{ t("paging.totalCount", [subscriptions.paging.total_count]) }})
                              </span>
                            </li>
                        </ul>
                        <ul class="pagination">
                            <li class="page-item">
                              <el-button :disabled="subscriptions.paging.page + 1 > totalPage" @click="handleNextPage">
                                {{ t("paging.nextPage") }}
                                <i class="czi-arrow-right ml-2"></i>
                              </el-button>
                            </li>
                        </ul>
                      </nav>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>

        <el-dialog v-model="dialogState.visible" :title="t('subscriptions.changePaymentMethod')">
          <el-form :model="dialogState.data">
            <el-form-item>
              <el-radio-group v-model="dialogState.data.payment_type" size="large" class="w-100 row m-0 justify-content-center">
                <el-radio
                  v-for="payment in payments"
                  :key="payment.type"
                  :label="payment.type"
                  border
                  class="col-12 mb-2 mx-1"
                  :style="{ minHeight: '5rem', margin: '0 0rem 0 0' }"
                >
                  {{ dt(payment.name_translations) }}
                  <div v-if="payment.show_description_on_checkout" class="text-black-50">
                    {{ dt(payment.description_translations) }}
                  </div>
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>

          <template #footer>
            <span class="dialog-footer">
              <el-button @click="dialogState.visible = false">{{ t("global.cancel") }}</el-button>
              <el-button type="primary" @click="handleChangePayment"
                >{{ t("global.ok") }}</el-button
              >
            </span>
          </template>
        </el-dialog>
	</div>
</template>

<script setup>
import { reactive, ref, computed, onMounted } from 'vue'
import { useI18n } from "vue-i18n"
import { notificationErrors, dateFormat, dataTranslations as dt, checkValidCurrencyStr } from "../../utils"
import { ElNotification } from 'element-plus'
import { _api_getSubscriptions, _api_putOrderPaymemnt } from "../../api/index.js";

const { t, n, locale } = useI18n()

const props = defineProps({
  payments: Array
})

const planTypeTabs = [
	{"label": t("subscriptions.paid"), "name": "COMMON"},
	{"label": t("subscriptions.giftRecord"), "name": "GIFT"},
]

const chooseTab = ref('COMMON')
const format = "YYYY/MM/DD hh:mm:ss"

const totalPage = computed(() => subscriptions.paging ? Math.ceil(subscriptions.paging.total_count / subscriptions.paging.limit) : null)
const filterParams = reactive({
  page: 1,
  limit: 10,
  plan_type: 'COMMON',
})
const subscriptions = reactive({
  data: [],
  paging: null,
})
const dialogState = reactive({
  visible: false,
  uuid: null,
  data: {
    payment_type: null,
  },
})


const getData = async () => {
  window.fullPageLoading("show")
  try {
    const resp = await _api_getSubscriptions(filterParams)
    subscriptions.data = resp.data
    subscriptions.paging = resp.paging
  } catch (err) {
    notificationErrors(err)
  } finally {
    window.fullPageLoading("hide")
  }
}
const handleClick = () => {
    filterParams.plan_type = chooseTab.value
    getData()
}
const handleChangePayment = async () => {
  window.fullPageLoading("show")
  try {
    await _api_putOrderPaymemnt(dialogState.uuid, dialogState.data)
    dialogState.visible = false
    ElNotification({
      title: t("subscriptions.changePaymentMethodSuccess"),
      // message: 'This is a success message',
      type: 'success',
      position: 'bottom-left',
    })
  } catch (err) {
    // console.log("handleChangePayment Fail: ", err)
    notificationErrors(err.response.data)
  } finally {
    window.fullPageLoading("hide")
  }
}
const onClickChangePayment = (item) => {
  dialogState.uuid = item.uuid
  dialogState.data.payment_type = item.payment_type
  dialogState.visible = true
}
const handlePrePage = () => {
  filterParams.page--
  getData()
}
const handleNextPage = () => {
  filterParams.page++
  getData()
}

onMounted(() => {
  getData()
})
</script>
<style>
    .list-item {
        border-bottom: 1px solid #b2b2b2;
        padding: 1rem 0.5rem;
    }
    .list-item__title {
        font-size: 1.125rem;
        margin-bottom: 0px;
    }
    .list-item__subtitle {
        font-size: .875rem;
        margin-bottom: 0px;
    }
</style>